import { render, staticRenderFns } from "./ItemSearch.vue?vue&type=template&id=1996dc70&scoped=true&"
import script from "./ItemSearch.vue?vue&type=script&lang=js&"
export * from "./ItemSearch.vue?vue&type=script&lang=js&"
import style0 from "./ItemSearch.vue?vue&type=style&index=0&id=1996dc70&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1996dc70",
  null
  
)

export default component.exports